import { getAdminChangeRequestSummary } from './analyticsChangeRequests';
import { APP_EVENTS } from '../utils/appEvents';

/**
 * FE-FIX11. Badge заявок читал один и тот же summary дважды: хук вызывается
 * и в Sidebar, и во вкладке «Заявки», и каждый экземпляр вешал собственный
 * visibilitychange. Возврат во вкладку браузера давал два одинаковых GET.
 *
 * Владелец слушателей и in-flight запроса — этот модуль. Snapshot намеренно
 * строка: useSyncExternalStore сравнивает через Object.is, и свежий объект
 * на каждый вызов давал бы бесконечный ре-рендер (та же причина, что в
 * hooks/useAuth.js).
 */
const isMissingEndpoint = (error) => {
  const status = error?.response?.status;
  return status === 404 || status === 501;
};

let enabled = true;
let state = 'loading';
let pendingCount = 0;
let snapshot = 'loading|0';
let inFlight = null;
let listenersBound = false;
const listeners = new Set();

const setValue = (nextState, nextCount) => {
  if (state === nextState && pendingCount === nextCount) return;
  state = nextState;
  pendingCount = nextCount;
  snapshot = `${state}|${pendingCount}`;
  listeners.forEach((listener) => listener());
};

export const refreshChangeRequestSummary = () => {
  if (!enabled) {
    setValue('unsupported', 0);
    return Promise.resolve();
  }

  // Второй запрос, пока летит первый, — это тот же самый запрос.
  if (inFlight) return inFlight;

  if (state !== 'ready') setValue('loading', pendingCount);

  inFlight = getAdminChangeRequestSummary()
    .then((summary) => { setValue('ready', summary.pendingCount); })
    .catch((error) => { setValue(isMissingEndpoint(error) ? 'unsupported' : 'error', 0); })
    .finally(() => { inFlight = null; });

  return inFlight;
};

const onVisible = () => {
  if (!document.hidden) refreshChangeRequestSummary();
};

const bindListeners = () => {
  if (listenersBound || typeof document === 'undefined') return;
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener(APP_EVENTS.CHANGE_REQUESTS_REFRESH, refreshChangeRequestSummary);
  listenersBound = true;
};

const unbindListeners = () => {
  if (!listenersBound || typeof document === 'undefined') return;
  document.removeEventListener('visibilitychange', onVisible);
  window.removeEventListener(APP_EVENTS.CHANGE_REQUESTS_REFRESH, refreshChangeRequestSummary);
  listenersBound = false;
};

export const subscribeChangeRequestSummary = (listener) => {
  listeners.add(listener);
  bindListeners();
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) unbindListeners();
  };
};

export const getChangeRequestSummarySnapshot = () => snapshot;

export const parseChangeRequestSummarySnapshot = (value) => {
  const [snapshotState, count] = String(value).split('|');
  return { state: snapshotState, pendingCount: Number(count) || 0 };
};

/**
 * Не-администратору summary недоступен: вместо 403 на каждый возврат во
 * вкладку store просто выключается.
 */
export const enableChangeRequestSummary = (value) => {
  if (enabled === value) return;
  enabled = value;
  if (!enabled) setValue('unsupported', 0);
};

export const resetChangeRequestSummaryStoreForTests = () => {
  unbindListeners();
  listeners.clear();
  inFlight = null;
  enabled = true;
  state = 'loading';
  pendingCount = 0;
  snapshot = 'loading|0';
};
